<template>
    <div>
        <div style="padding: 0 20px">
            <div class="top">
                <div>                    
                    <el-button type="primary" @click="addType()" style="width: 96px">新增</el-button>
                </div>
               
            </div>
            <div>
                <el-table :data="tableData"
                          v-loading="loading"
                          :header-cell-style="{'padding-left': '3%'}"
                          :cell-style="{'padding-left': '3%'}">
                    <el-table-column prop="id" label="ID"></el-table-column>                   
                    <el-table-column prop="name" label="问题分类名称"></el-table-column>
                    <el-table-column label="终端">
                        <template slot-scope="scope">
                            <span v-if="scope.row.side === 1">医生端</span>
                            <span v-else>患者端</span>
                        </template>
                    </el-table-column>
                    <el-table-column label="状态">
                        <template slot-scope="scope">
                            <span v-if="scope.row.state === 1">正常</span>
                            <span v-else>删除</span>
                        </template>
                    </el-table-column>
                    <el-table-column label="操作">
                        <template slot-scope="scope">                        
                        <el-button type="text" @click="edit(scope.row)">查看</el-button>
                        <el-button type="text" @click="del(scope.row)">删除</el-button>
                        </template>
                    </el-table-column>                                        
                    
                </el-table>
            </div>
    
        </div>
        <el-dialog title="新增问题分类" :visible.sync="dialogAddVisible" width="560px"
                   :close-on-click-modal="false" :before-close="cancelAdd">
            <el-form :model="typeAdd" ref="add" size="small" label-width="90px">

                <el-form-item label="终端:" prop="side">
                   <el-select size="small" style="width: 150px;margin-right: 20px" v-model="typeAdd.side">				
                        <el-option label="患者端" :value="0"></el-option>
                        <el-option label="医生端" :value="1"></el-option>	
					</el-select>
                </el-form-item>

                <el-form-item label="问题分类:" prop="name">
                    <el-input v-model="typeAdd.name" style="width: 320px"></el-input>
                </el-form-item>          
               
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click="cancelAdd" style="width: 76px">取 消</el-button>
                <el-button type="primary" @click="confirmAdd" style="width: 76px;">确 定</el-button>
            </div>
        </el-dialog>

        <el-dialog title="编辑问题分类" :visible.sync="dialogEditVisible" width="560px"
                   :close-on-click-modal="false" :before-close="cancelEdit">
            <el-form :model="typeEdit"  ref="edit" size="small" label-width="90px">
                <el-form-item label="终端:" prop="side">
                 <el-select size="small" style="width: 150px;margin-right: 20px" v-model="typeEdit.side">				
                        <el-option label="患者端" :value="0"></el-option>
                        <el-option label="医生端" :value="1"></el-option>	
					</el-select>
                </el-form-item>

                <el-form-item label="问题分类:" prop="name">
                    <el-input v-model="typeEdit.name" style="width: 320px"></el-input>
                </el-form-item>              
               
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click="cancelEdit" style="width: 76px">取 消</el-button>
                <el-button type="primary" @click="confirmEdit" style="width: 76px;">确 定</el-button>
            </div>
        </el-dialog>

    </div>
</template>

<script>    
    export default {
       
        data() {
            return {
                authorization:localStorage.getItem('authorization'),                
                loading: true,
                tableData: [],
                dialogAddVisible:false,
                typeAdd:{
                    side:1,
                    name:'',
                    state:1,                   

                },
               
                dialogEditVisible:false,
                typeEdit:{
                    id:'',
                    side:'',
                    name:'',
                    state:'',
                    
                }
                
               
            };
        },
        methods: {
            // 获取科室列表
            getData() {
                this.loading = true                
                this.axios.get('api-b/10056/100560/1',{
                    headers:{
                        Authorization: this.authorization
                    }
                }).then(res => {
                    console.log(res.data)
                    if (res.data.code === 10000) {
                        if (res.data.data.length === 0) {
                            this.$message.info('暂无数据')
                        }
                        this.tableData = res.data.data
                        
                    } else {
                        this.$message.error(res.data.message)
                        this.tableData = []
                        
                    }
                    this.loading = false
                }).catch(error => {
                    this.tableData = []
                    
                    this.loading = false
                })
            },
           
        cancelAdd() {
            this.dialogAddVisible = false
            this.$nextTick(() => {
                this.$refs.add.resetFields()
            })
        },
        // 新增科室弹窗按钮
        addType() {            
            this.dialogAddVisible = true
        },
        confirmAdd(){
            this.$refs.add.validate(valid => {                                            
                let params = {
                    side:this.typeAdd.side,
                    name:this.typeAdd.name,
                    state:this.typeAdd.state,                   
                                                
                }
                this.axios.post('api-b/10056/100561/',params,{
                    headers:{
                        Authorization: this.authorization
                    }
                }).then(res => {
                    if (res.data.code === 10000) {
                        this.dialogAddVisible = false
                        this.$message.success(res.data.message)
                        this.getData()
                    
                    } else {
                        this.$message.error(res.data.message)
                    }
                })
                
            })

        },
        cancelEdit() {
                this.dialogEditVisible = false
                this.$nextTick(() => {
                    this.$refs.edit.clearValidate()
                })
            },
        // 编辑医生弹窗按钮
        edit(data) {
            
            this.axios.get('/api-b/10056/100563/' + data.id,{
            headers:{
                Authorization: this.authorization,
            }
            }).then(res => {
                
                if(res.data.code=== 10000) {
                    if (res.data.data !== null) {
                        this.dialogEditVisible = true
                        this.typeEdit = res.data.data
                        
                    } else {
                        this.$message.info(res.data.message)
                    }
                } else {
                    this.$message.error(res.data.message)
                }
            })
        },
            
        confirmEdit() {
            this.$refs.edit.validate(valid => {                
                let params = {
                    id:this.typeEdit.id,
                    side:this.typeEdit.side,
                    name:this.typeEdit.name,
                    state:this.typeEdit.state                   
                                                
                }
                this.axios.post('/api-b/10056/100561',params,{
                    headers:{
                        Authorization: this.authorization
                    }
                }).then(res => {
                    if (res.data.code === 10000) {
                        this.dialogEditVisible = false
                        this.$message.success(res.data.message)
                        this.getData()
                        this.$nextTick(() => {
                            this.$refs.edit.resetFields()                            
                        })
                    } else {
                        this.$message.error(res.data.message)
                    }
                })

               
            })
        },
       
        del(data){
            const h = this.$createElement;
            this.$msgbox({
                message: h('div',{class:'message-box'}, [
                    h('div', { class: 'message-title-box'}, [
                        h('i', { class:'el-icon-warning message-box-icon' }, ''),
                        h('span', { class:'message-box-title'}, '确认要删除该分类吗？'),
                    ]),
                    
                ]),
                showCancelButton: true,
                confirmButtonText: '确定',
                cancelButtonText: '取消',
            }).then(() => {                
                
                this.axios.get('/api-b/10056/100562/' + data.id,{
                    headers:{
                        Authorization: this.authorization
                    }
                }).then(res => {
                    if (res.data.code === 10000) {
                        this.$message.success(res.data.message)
                        this.getData()
                    } else {
                        this.$message.error(res.data.message)
                        this.getData()
                    }
                }).catch(error => {})
            })

        }

           
        },
        watch: {
            
        },
        created() {
            this.getData()
        }
    };
</script>

<style>

</style>
<style scoped>
    .top {
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        margin-top: 12px;
        height: 52px;
    }
    .delete-button {
        margin-left: 20px;
        color: rgba(255,75,75,1) !important;
    }
    .delete-button:hover {
        color: rgba(255,75,75,0.8) !important;
    }
    .delete-button:focus {
        color: rgba(215,37,41,1) !important;
    }
    .dialog-set{
        display: flex;
        flex-direction: row;
        justify-content: flex-start;
    }
    .tag-box {
        width: 288px;
        min-height: 30px;
        border-radius: 5px;
        border: 1px solid #DCDFE6;
        padding: 0 15px
    }
    .push {
        color:rgba(238,238,238,1);
        font-size: 32px;
        position: absolute;
        top: 30px;
        left: 30px;
    }
    .course-img {
        position: absolute;
        top: 1px;
        width: 92px;
        height: 92px;
    }
     .upload-input {
        opacity: 0;
        width: 92px;
        height: 92px;
        position: absolute;
        top: 0;
    }
</style>